import DownloadAppPageDesktop from './Desktop';
import DownloadAppPageMobile from './Mobile';
import { detectPlatform } from 'src/utils/detectPlatform';

const DownloadAppPage = () => {
  const isMobile = detectPlatform() === 'iOS' || detectPlatform() === 'Android';
  return isMobile ? <DownloadAppPageMobile /> : <DownloadAppPageDesktop />;
};

export default DownloadAppPage;
